import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { BaseQuestionListPluginProps } from '../QuestionListPlugin.types';

const Main = styled.ol`
  padding-inline-start: 20px;
`;

interface QuestionListProps extends BaseQuestionListPluginProps {}

export const QuestionList = (props: QuestionListProps) => {
  const { attributes, children, element } = props;
  return (
    <Main {...attributes} className={cl('question-list-element', element.id)}>
      {children}
    </Main>
  );
};
